(() => {
  if (customElements.get('pdp-expanded-recommendations')) return;
  class ExpandedRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.grid = this.querySelector('[data-recommendation-grid]');
      this.more = this.querySelector('[data-recommendation-more]');
      this.count = this.querySelector('[data-recommendation-count]');
      if (!this.grid || !this.more || !this.count) return;
      this.initialized = true;
      this.cards = Array.from(this.grid.children);
      this.media = window.matchMedia('(max-width: 767px)');
      this.expanded = false;
      this.shown = this.initialCount();
      this.onResize = () => {
        if (!this.expanded) this.shown = this.initialCount();
        this.render();
      };
      this.onMore = () => {
        const firstNew = this.shown;
        this.expanded = true;
        this.shown = Math.min(this.cards.length, this.shown + this.batchSize());
        this.render();
        const card = this.cards[firstNew];
        const link = card?.querySelector('.product-link[href]:not([tabindex="-1"]):not([aria-hidden="true"])') || card?.querySelector('a[href]:not([tabindex="-1"]):not([aria-hidden="true"]), button:not([disabled])');
        if (link) link.focus({ preventScroll: true });
      };
      this.more.addEventListener('click', this.onMore);
      this.media.addEventListener('change', this.onResize);
      this.render();
      this.setAttribute('data-enhanced', '');
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.more.removeEventListener('click', this.onMore);
      this.media.removeEventListener('change', this.onResize);
      this.initialized = false;
    }
    batchSize() {
      return Number(this.media.matches ? this.dataset.mobileCount : this.dataset.desktopCount) || (this.media.matches ? 8 : 12);
    }
    initialCount() {
      return Math.min(this.cards.length, this.batchSize());
    }
    render() {
      this.cards.forEach((card, index) => {
        card.hidden = index >= this.shown;
        if (!card.hidden) {
          card.querySelectorAll('[data-manual-srcset], [data-manual-src]').forEach(image => {
            if (image.dataset.manualSrcset) {
              image.setAttribute('srcset', image.dataset.manualSrcset);
              delete image.dataset.manualSrcset;
            }
            if (image.dataset.manualSrc) {
              image.setAttribute('src', image.dataset.manualSrc);
              delete image.dataset.manualSrc;
            }
          });
        }
      });
      this.more.hidden = this.shown >= this.cards.length;
      this.count.textContent = this.dataset.countLabel.replaceAll('[count]', this.shown).replaceAll('[total]', this.cards.length);
    }
  }
  customElements.define('pdp-expanded-recommendations', ExpandedRecommendations);
})();
